module.exports = __webpack_public_path__ + "img/icon-coin.fd8b1617.png";